// 页面类型
export const pageType = {
  homePage: "homePage", //首页
  articleListPage: "articleListPage", // 文章列表
  articleDetailPage: "articleDetailPage", // 文章详情
  searchPage: "searchPage", // 搜索
};

// 页面访问来源
export const pageSourceType = {
  swiper: "swiper", // 轮播图
  recommendList: "recommendList", // 推荐列表
  articleList: "articleList", // 文章列表
  searchResult: "searchResult", // 搜索结果
  homeClass: "homeClass", // 首页分类入口
  navigation: "navigation", // 导航
  articleDetailTag: "articleDetailTag", // 文章详情页面标签
  articleDetailPage: "articleDetailPage", //文章详情页面
};

// 外链类型
export const redirectLinkType = {
  activity: "activity", //平台活动
  facebook: "facebook", //Facebook
  twitter: "twitter", //twitter
  discord: "discord", //discord
  other: "other", //其他
};

/**
  页面展示
  pageKey: 页面类型key
  pageSourceKey: 页面访问来源
  id: 文章列表，记录当前选中的分类id
      文章内容，记录当前选中的文章id
  moduleName: 模块标识
*/
export const viewPagePoint = ({ pageKey, pageSourceKey, id, moduleName }) => {
  window.officialGuideDataLayer.push({
    eventName: "view_page",
    eventType: pageType[pageKey] || pageKey || "",
    eventReason: pageSourceType[pageSourceKey] || pageSourceKey || "",
    eventValue: {
      id: id || "",
      moduleName: moduleName || "",
    },
  });
};

/**
    按钮点击
    btnName: 按钮名称
    reason: 按钮所属模块
*/
export const clickButtonPoint = ({ btnName, moduleName, otherParams = {} }) => {
  window.officialGuideDataLayer.push({
    eventName: "click_button",
    eventType: btnName || "",
    eventReason: moduleName,
    eventValue: otherParams,
  });
};

export const goLinkPoint = (link, source) => {
  const lowerCaseLink = link.toLowerCase();
  const linkType =
    [
      { keyword: "facebook", type: redirectLinkType.facebook },
      { keyword: "twitter", type: redirectLinkType.twitter },
      { keyword: "discord", type: redirectLinkType.discord },
      { keyword: "gevents", type: redirectLinkType.activity },
      { keyword: "auto-page", type: redirectLinkType.activity },
      { keyword: "auto-page-preview", type: redirectLinkType.activity },
    ].find((item) => lowerCaseLink.indexOf(item.keyword) > -1)?.type ||
    redirectLinkType.other;
  window.officialGuideDataLayer.push({
    eventName: "go_link",
    eventType: linkType,
    eventReason: source || "",
    eventValue: {
      url: link,
    },
  });
};
